import { render, staticRenderFns } from "./offer-product-list-item-group.vue?vue&type=template&id=072e21f7&"
import script from "./offer-product-list-item-group.vue.ts?vue&type=script&lang=ts&"
export * from "./offer-product-list-item-group.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports